<template>
  <div data-testid="layout-container">
    <TheHeader />
    <Authenticator :hide-sign-up="true" :login-mechanisms="['email']">
      <template #sign-in-header>
        <h3 class="amplify-heading amplify-heading--3 login-heading">Login</h3>
      </template>
      <template #default>
        <div class="mt-4">
          <section>
            <div class="mx-auto px-4">
              <router-view />
            </div>
          </section>
        </div>
      </template>
    </Authenticator>
  </div>
</template>

<script lang="ts">
import { Authenticator } from '@aws-amplify/ui-vue';
import { defineComponent } from 'vue';
import TheHeader from '@/components/layout/TheHeader.vue';

export default defineComponent({
  components: {
    Authenticator,
    TheHeader,
  },
});
</script>

<style scoped>
.login-heading {
  padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
}
</style>
